import i18n from "@/i18n"

export const codeMapping = {
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.INVALID_FORMAT': () => i18n.t('fleetTaskInstant.toast.importData.invalidFormat'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.QUICK_ASSIGNMENT_ID_DUPLICATE': () => i18n.t('fleetTaskInstant.toast.importData.idDuplicate'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.POINT_SEQUENCE_DUPLICATE': () => i18n.t('fleetTaskInstant.toast.importData.pointSequenceDuplicate'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.QUICK_ASSIGNMENT_ID_NOT_FOUND': () => i18n.t('fleetTaskInstant.toast.importData.idNotFound'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.VEHICLE_DUPLICATE': () => i18n.t('fleetTaskInstant.toast.importData.vehicleDuplicate'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.DRIVER_DUPLICATE': () => i18n.t('fleetTaskInstant.toast.importData.driverDuplicate'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.VEHICLE_NOT_FOUND': () => i18n.t('fleetTaskInstant.toast.importData.vehicleNotFound'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.DRIVER_NOT_FOUND': () => i18n.t('fleetTaskInstant.toast.importData.driverNotFound'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.MASTER_DATA_ADDRESS_NOT_FOUND':
() => i18n.t('fleetTaskInstant.toast.importData.addressNotFound'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.GOOGLE_ADDRESS_NOT_FOUND': () => i18n.t('fleetTaskInstant.toast.importData.googleAddressNotFound'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.COORDINATE_ADDRESS_NOT_FOUND':
    () => i18n.t('fleetTaskInstant.toast.importData.coordinateAddressNotFound'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.QUICK_ASSIGNMENT_CALCULATION_TARGET_INVALID': () => i18n.t('fleetTaskInstant.toast.importData.calculationTargetInvalid'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.QUICK_ASSIGNMENT_OPTIMIZATION_INVALID': () => i18n.t('fleetTaskInstant.toast.importData.optimizationInvalid'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.POINT_OVERLAP': () => i18n.t('fleetTaskInstant.toast.importData.pointOverlap'),
  'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.EMPTY_POINT': () => i18n.t('fleetTaskInstant.toast.importData.emptyPoint'),
  'FLEET_TASK.VEHICLE_STATUS_INVALID': () => i18n.t('fleetTaskInstant.toast.importData.vehicleStatusInvalid'),
  'FLEET_TASK.DRIVER_USER_GROUP_INVALID': () => i18n.t('fleetTaskInstant.toast.importData.driverUserGroupInvalid'),
  'FLEET_TASK.VEHICLE_GROUP_INVALID': () => i18n.t('fleetTaskInstant.toast.importData.vehicleGroupInvalid'),
}

export const setInvalidFormatMessage = (value, message) => {
  let formattedValue = value
  
  if (value.includes('*')) {
    formattedValue = formattedValue.replace('*', '')
  }

  if (message === 'cannot be blank') {
    return i18n.t('fleetTaskInstant.toast.importData.emptyCustomField', {ob: formattedValue})
  }

  return i18n.t("fleetTaskInstant.toast.importData.invalidCustomFieldFormat", { obj: formattedValue})
}
